import { ApolloLink, Observable, FetchResult } from '@apollo/client';
import { print } from 'graphql';

export const xhrProgressLink = (uploadURL: string) =>
  new ApolloLink((operation, forward) => {
    console.debug('XHR Progress Link', operation);
    if (!operation.variables?.file) {
      return forward ? forward(operation) : null;
    }

    return new Observable<FetchResult>((observer) => {
      const { query, variables, operationName } = operation;

      const form = new FormData();
      form.append(
        'operations',
        JSON.stringify({ query: print(query), variables, operationName }),
      );
      form.append('map', JSON.stringify({ '1': ['variables.file'] }));
      form.append('1', variables.file as File);

      const xhr = new XMLHttpRequest();
      xhr.open('POST', uploadURL);
      const { headers = {} } = operation.getContext();
      Object.entries(headers).forEach(([k, v]) =>
        xhr.setRequestHeader(k, v as string),
      );

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          operation
            .getContext()
            .onUploadProgress?.(Math.round((e.loaded / e.total) * 100));
        }
      };

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status >= 200 && xhr.status < 300) {
            observer.next(JSON.parse(xhr.responseText));
            observer.complete();
          } else {
            observer.error(new Error(xhr.statusText));
          }
        }
      };

      xhr.send(form);
      return () => xhr.abort();
    });
  });
